import React, { useContext } from 'react'
import { FacilityContext } from '../../providers/FacilityProvider'
import useAuth from '../../utilities/hooks/useAuth'

export default function DemoNotice() {
  const context = useContext(FacilityContext)
  const { currentUser } = useAuth()
  if (!context?.facility?.demo && !currentUser?.demo) return null

  return (
    <div role="note" className="border-b border-purple-200 bg-purple-50 px-4 py-3 text-sm text-purple-900">
      <strong>Shared demo:</strong> use fictional data. Changes are shared. Email and payments are disabled.
    </div>
  )
}
